import styled from "@emotion/styled";
import { PageHeader } from "components/Common/Page";

export const LeadAssignmentsPageContainer = styled.div({
	width: "100%",
	minWidth: 0,
	overflow: "hidden"
});

export const LeadAssignmentsPageHeader = styled(PageHeader)(({ theme }) => ({
	width: "100%",
	padding: "20px 32px"
}));

export const LeadAssignmentsPageContentContainer = styled.div({
	padding: "16px 20px",
	minWidth: 0
});

export const LeadAssignmentsPageContent = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: "16px",
	display: "flex",
	flexDirection: "column",
	gap: "16px",
	minWidth: 0
}));
